import { render } from "./tw-router-view.vue?vue&type=template&id=351731c4"
import script from "./tw-router-view.vue?vue&type=script&lang=js"
export * from "./tw-router-view.vue?vue&type=script&lang=js"
script.render = render

export default script